import { FilterOption } from '../../components/_WMS/FilterComponent'
import { PositionAutoCompleter } from '../../components/PositionNew/components/PositionAutoCompleter'
import { createBackendTransformer, createDisplayTransformer } from '../../types/filters'

export const filterOptions: FilterOption[] = [
  {
    order: 1,
    key: 'warehouseId',
    label: 'Almacén',
    type: 'precreated'
  },
  {
    order: 2,
    key: 'sku',
    label: 'SKU',
    type: 'text'
  },
  {
    order: 3,
    key: 'ean13',
    label: 'EAN13',
    type: 'text'
  },
  {
    order: 4,
    key: 'asnId',
    label: 'ASN ID',
    type: 'numeric'
  },
  {
    order: 5,
    key: 'batchNumber',
    label: 'Lote',
    type: 'text'
  },
  {
    order: 6,
    key: 'positionCode',
    label: 'Nombre Posición',
    type: 'custom',
    Component: PositionAutoCompleter,
    transformForBackend: createBackendTransformer(),
    transformForDisplay: createDisplayTransformer()
  },
  {
    order: 7,
    key: 'typePositionId',
    label: 'Tipo Posición',
    type: 'precreated'
  },
  {
    order: 8,
    key: 'typeMovementId',
    label: 'Tipo Movimiento',
    type: 'precreated',
    canBeRepeated: true
  },
  {
    order: 9,
    key: 'workorderId',
    label: 'OT',
    type: 'numeric'
  },
  {
    order: 10,
    key: 'productOriginId',
    label: 'Marca',
    type: 'precreated'
  },
  {
    order: 11,
    key: 'pickingRouteId',
    label: 'Ruta Picking',
    type: 'numeric'
  },
  {
    order: 12,
    key: 'userEmail',
    label: 'Usuario',
    type: 'text'
  },
  {
    order: 13,
    key: 'movementDateRange',
    label: 'Rango de Fechas de Movimiento',
    type: 'daterange',
    canBeRepeated: false
  },
  {
    order: 14,
    key: 'expirationDateRange',
    label: 'Rango de Fechas de Expiración',
    type: 'daterange',
    canBeRepeated: false
  }
]

export const defaultFilters = []
